

















































































































import Vue from 'vue';
import Pagination from '@/components/Base/Pagination.vue';

export default Vue.extend({
  name: 'AdminUser',
  data() {
    return {
      activePage: 1,
      itemsPerPage: 30,
      filter: '',
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.$store.dispatch('clearFilters');
    this.$store.dispatch('loadUsers');
  },
  methods: {
    setActivePage(value: number): void {
      this.activePage = value;
    },
  },
  computed: {
    usersfiltered: function() {
      if (this.filter == '') {
        return this.$store.state.users;
      } else {
        return this.$store.state.users.filter((item) => item.email.toLowerCase().includes(this.filter.toLowerCase()));
      }
    },
    userspaged: function(): Array<any> {
      return this.usersfiltered.slice((this.activePage - 1) * this.itemsPerPage, this.activePage * this.itemsPerPage);
    },
    paged: function(): boolean {
      return this.usersfiltered.length > this.itemsPerPage;
    },
    pages: function(): number {
      return Math.ceil(this.usersfiltered.length / this.itemsPerPage);
    },
  },
});
